import * as React from "react";
import { SVGProps } from "react";

const ServerError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="127"
    height="115"
    viewBox="0 0 127 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_53818_43142)">
      <path
        d="M43.1572 22.9058C47.9948 13.7383 60.9577 13.2846 66.4244 22.0915L99.781 75.8283C105.219 84.5887 99.1549 95.954 88.8502 96.3147L25.9755 98.5153C15.6709 98.876 8.82703 87.9625 13.6392 78.8433L43.1572 22.9058Z"
        fill="#E7EBEE"
      />
      <path
        d="M50.803 22.1518C56.2269 13.3613 69.1328 13.7387 74.0337 22.8312L103.933 78.3034C108.834 87.3959 102.054 98.384 91.7294 98.0821L28.7393 96.2397C18.4146 95.9377 12.2885 84.5721 17.7124 75.7816L50.803 22.1518Z"
        fill="#F6F7F7"
      />
      <path
        d="M76.4604 6.49951L73.2125 13.6859"
        stroke="#E67068"
        stroke-width="1.74908"
        stroke-linecap="round"
      />
      <path
        d="M80.8662 14.1978L77.9267 16.148"
        stroke="#E67068"
        stroke-width="1.74908"
        stroke-linecap="round"
      />
      <path
        d="M67.5984 7.44163L68.791 12.8294"
        stroke="#E67068"
        stroke-width="1.74908"
        stroke-linecap="round"
      />
      <path
        d="M77.7471 65.728L78.9969 68.2497"
        stroke="#E67068"
        stroke-width="0.880936"
        stroke-linecap="round"
      />
      <path
        d="M79.6753 66.3428L77.0691 67.6344"
        stroke="#E67068"
        stroke-width="0.880935"
        stroke-linecap="round"
      />
      <path
        d="M84.8025 27.5973C85.5562 27.2239 86.436 27.5203 86.7822 28.2183C87.1282 28.9166 86.8316 29.7969 86.0779 30.1707C85.3239 30.5444 84.4429 30.2476 84.0968 29.5492C83.7509 28.8509 84.0486 27.971 84.8025 27.5973Z"
        stroke="#D0D6DB"
        stroke-width="0.880936"
      />
      <path
        d="M87.1902 48.3465C88.1155 47.8879 89.1939 48.2529 89.6171 49.1066C90.0399 49.9603 89.677 51.0388 88.7518 51.4973C87.8266 51.9558 86.7486 51.5916 86.3253 50.7381C85.9022 49.8843 86.2649 48.8051 87.1902 48.3465Z"
        stroke="#D0D6DB"
        stroke-width="1.17458"
      />
      <path
        d="M57.8421 62.1688L56.4197 48.6257C56.1495 45.9865 55.9942 44.0907 55.9539 42.9381C55.899 41.3698 56.2806 40.1362 57.0988 39.2373C57.9361 38.3188 59.0553 37.835 60.4564 37.786C62.1536 37.7266 63.3082 38.2537 63.9202 39.3674C64.5315 40.4622 64.8742 42.0678 64.9483 44.184C64.9919 45.4311 64.9672 46.6995 64.874 47.9892L64.0902 62.0069C64.0102 63.6745 63.7588 64.9603 63.336 65.8642C62.9132 66.7682 62.1788 67.2385 61.1329 67.2751C60.0672 67.3124 59.3123 66.9132 58.8681 66.0774C58.4232 65.2227 58.0813 63.9198 57.8421 62.1688ZM61.7807 80.7034C60.5769 80.7456 59.5082 80.4141 58.5746 79.7089C57.6601 78.9842 57.1794 77.9511 57.1324 76.6095C57.0914 75.438 57.481 74.4311 58.3011 73.5889C59.1404 72.7271 60.1816 72.2745 61.4249 72.231C62.6682 72.1875 63.7386 72.5662 64.636 73.3672C65.5525 74.1486 66.0312 75.1251 66.0722 76.2966C66.1185 77.6193 65.7109 78.674 64.8493 79.4609C63.9876 80.2478 62.9648 80.662 61.7807 80.7034Z"
        fill="#C9D0D6"
      />
    </g>
    <defs>
      <clipPath id="clip0_53818_43142">
        <rect width="126.129" height="114.5" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ServerError;
